import { Litepicker } from 'litepicker/dist/nocss/litepicker.umd.js';
import 'litepicker/dist/nocss/plugins/keyboardnav';
import 'litepicker/dist/nocss/plugins/mobilefriendly';

const litepickerMounts = Array.from(document.querySelectorAll('.quick-request__date-litepicker'));
const language = document.documentElement.lang;

const litepickerConfig = Object.assign(
    {
        singleMode: false,
        lang: language,
        minDate: Date.now(),
        showTooltip: false,
        plugins: ['keyboardnav', 'mobilefriendly'],
    },
    window.litepickerConfig ?? {}
);

litepickerMounts.forEach(mount => {
    const config = Object.assign({ element: mount }, litepickerConfig);
    const litepicker = new Litepicker(config);
});
